module.exports = __webpack_public_path__ + "static/img/pc.3d613df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/长城书院/pc.svg
// module id = 2Gmv
// module chunks = 16